// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice_notice__3zP0t","download":"notice_download__3_9cN","btn-download":"notice_btn-download__1NLmL"};